// extracted by mini-css-extract-plugin
export default {"waiting-room-mute-button-muted":"Footer_waiting-room-mute-button-muted__GhGBn","anticon":"Footer_anticon__0IBHG","c-footer":"Footer_c-footer__pElq1"};